import type { MechKey } from './keys';

export const ar: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'الميكانيكا · 2D',
  'panel.scene': 'المشهد',
  'panel.dims': 'المعاملات',
  'panel.style': 'المظهر',
  'panel.action': 'التحكم',
  'style.body': 'الجسم',
  'style.vector': 'المتجهات',
  'style.ground': 'الأرض',
  'style.forces': 'إظهار القوى',
  'style.trace': 'إظهار المسار',
  'style.labels': 'تسميات المتجهات',
  'hint.line1': 'انقر تشغيل للبدء · اسحب الأجسام لتحريكها',
  'hint.line2': 'ساحة اللعب: اختر شكلاً ثم انقر لوضعه',
  'scene.incline': 'المستوى المائل',
  'scene.projectile': 'حركة القذيفة',
  'scene.pendulum': 'البندول',
  'scene.springMass': 'نظام الزنبرك والكتلة',
  'scene.collisions': 'التصادمات',
  'scene.atwood': 'آلة أتوود',
  'scene.circular': 'الحركة الدائرية',
  'scene.sandbox': 'ساحة اللعب',
  'dim.angle': 'الزاوية (°)',
  'dim.friction': 'الاحتكاك',
  'dim.mass': 'الكتلة',
  'dim.massA': 'الكتلة A',
  'dim.massB': 'الكتلة B',
  'dim.velocity': 'السرعة',
  'dim.angleLaunch': 'زاوية الإطلاق (°)',
  'dim.gravity': 'الجاذبية',
  'dim.gravityX': 'الجاذبية x',
  'dim.gravityY': 'الجاذبية y',
  'dim.length': 'الطول',
  'dim.damping': 'التخميد',
  'dim.spring': 'الصلابة',
  'dim.restitution': 'معامل الارتداد',
  'dim.radius': 'نصف القطر',
  'dim.speed': 'السرعة الاتجاهية',
  'action.play': 'تشغيل',
  'action.pause': 'إيقاف مؤقت',
  'action.step': 'خطوة',
  'action.reset': 'إعادة تعيين',
  'action.speed': 'السرعة',
  'action.clear': 'مسح',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'الجاذبية',
  'forceName.normal': 'القوة العمودية',
  'forceName.friction': 'الاحتكاك',
  'forceName.tension': 'الشد',
  'forceName.spring': 'قوة الزنبرك',
  'forceName.applied': 'قوة مسلطة',
  'forceName.air': 'مقاومة الهواء',
  'palette.box': 'صندوق',
  'palette.circle': 'كرة',
  'palette.ramp': 'منحدر',
  'palette.ground': 'أرض',
  'palette.hint': 'اختر شكلاً ثم انقر على اللوحة لوضعه.',
  'panel.forces': 'القوى المرصودة',
  'forces.empty': 'لا شيء بعد — شغّل المشهد',
};
